<template>
  <div class="banner">
    <div class="banner-img" :style="bannerStyle"></div>
      <customBreadcrumb :crumbList="crumbList" :currentAsH1="crumbAsH1"></customBreadcrumb>
      <div v-if="isShowBase" class="banner-content">
          <slot name="top"></slot>
          <div class="wrap">
              <component
                :is="titleTag"
                class="h1-title word_break"
                :class="{'MultiLine2':locale=='zh-CN'}"
              >{{title}}</component>
              <p class="desc word_break" :class="{'MultiLine2':locale=='zh-CN'}" v-if="subTitle">{{subTitle}}</p>
          </div>
          <slot name="bottom"></slot>
      </div>
      <slot></slot>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n' // 导入 useI18n
const { locale, t } = useI18n() // 获取当前 i18n 语言（如 zh-CN/en-US）
const isClient = ref(false);
// 定义组件 props，包含所有背景相关配置，都设置了默认值保持原有效果
const props = withDefaults(
  defineProps<{
    /** 背景图片地址 */
    bgImage?: string;
    /** 背景颜色 */
    bgColor?: string;
    /** 背景定位（如：center left */
    bgPosition?: string;
    /** 背景重复（如：no-repeat/repeat） */
    bgRepeat?: string;
    /** 背景尺寸（如：cover/contain/100% 100%） */
    bgSize?: string;
    /** 是否显示title，以及描述 */
    isShowBase?: boolean;
    /** title */
    title?: string;
    /** 描述 */
    subTitle?: string;
    crumbList?: string[];
    defaultImg?:string;
    /** 标题标签，默认 h1；国际版 SEO 可改为 span */
    titleTag?: 'h1' | 'span';
    /** 面包屑当前页是否包一层 h1（与 titleTag=span 配合，保证页内唯一 h1） */
    crumbAsH1?: boolean;
  }>(),
  {
    // 配置 isShowBase 默认值为 true
    isShowBase: true, 
    title: '',
    bgImage: '',
    subTitle: '',
    defaultImg: '',
    crumbList: () => [],
    titleTag: 'h1',
    crumbAsH1: false,
  }
);

// 计算最终的样式对象
const bannerStyle = computed(() => {
  // 确保服务端和客户端使用相同的bgImage处理逻辑
  const finalBgImage = props.bgImage || '';
  
  return {
    // backgroundColor: props.bgColor || '#030b19',
    backgroundPosition: props.bgPosition || 'left center',
    backgroundRepeat: props.bgRepeat || 'no-repeat',
    backgroundSize: props.bgSize || 'cover',
    // 直接使用传递的bgImage，不做额外处理
    backgroundImage: finalBgImage ? `url('${finalBgImage}')` : props.defaultImg,
  };
});
onMounted(() => {
  isClient.value = true;
});
</script>

<style lang="scss" scoped>
/* 基础样式保持，动态样式通过内联样式绑定 */
.banner {
  display: block;
  position:relative;
  width: 100%;
  height: 100vh;
  min-height: 700px;
  z-index: 1;
  overflow: hidden;
  background-color: #030b19;
  &::before{
    display: block;
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    width: 32px;
    height: 32px;
    margin-left: -16px;
    margin-top: -16px;
    background: url('@/assets/images/icon/loading.png') center center no-repeat;
    background-size: contain;
    z-index: -1;
    animation: spin 1s linear infinite;
  }
  .banner-img{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.banner-content{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: left;  /* 保持左对齐风格 */
    width: 100%;
    .h1-title{
      width: 60%;
      max-width: 922px;
    }
    .desc{
        max-width: 922px;
        margin-top:var(--spacing-12);
        line-height:26px;
        font-size:16px;
        color:#fff;

    }
}
// @media (max-width: 1200px) {
//   .banner{
//     min-height: 720px;
//   }
// }
// @media (max-width: 990px) {
//   .banner{
//     min-height: 700px;
//   }
// }
@media (max-width: 767px) {
  .banner{
    min-height: 0;
    height: 580px;
    max-height: 100vh;
    .banner-img{
      position: absolute;
      left: 0;
      top: 0;
      height: 100% !important;
    }
  }
  .banner-content{
    .h1-title{
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    .desc{
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
    }
  }
}
</style>